(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define([], factory);
	else if(typeof exports === 'object')
		exports["@makolab/library-react/dist/PictureLoading"] = factory();
	else
		root["@makolab/library-react/dist/PictureLoading"] = factory();
})(this, function() {
return /******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, {
/******/ 				configurable: false,
/******/ 				enumerable: true,
/******/ 				get: getter
/******/ 			});
/******/ 		}
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "/project_fcn_library-react/";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = 359);
/******/ })
/************************************************************************/
/******/ ({

/***/ 0:
/***/ (function(module, exports) {

module.exports = require("prop-types");

/***/ }),

/***/ 1:
/***/ (function(module, exports) {

module.exports = require("react");

/***/ }),

/***/ 2:
/***/ (function(module, exports) {

module.exports = require("@material-ui/core/styles");

/***/ }),

/***/ 3:
/***/ (function(module, exports) {

module.exports = require("lodash/flow");

/***/ }),

/***/ 359:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "PictureLoading", function() { return PictureLoading; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash_flow__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash_flow___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_lodash_flow__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__material_ui_core_styles__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__material_ui_core_styles___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__material_ui_core_styles__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__picture_jss_js__ = __webpack_require__(360);
function _defineProperty(obj,key,value){if(key in obj){Object.defineProperty(obj,key,{value:value,enumerable:true,configurable:true,writable:true});}else{obj[key]=value;}return obj;}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var PictureLoading=function(_Component){_inherits(PictureLoading,_Component);function PictureLoading(){var _ref;var _temp,_this,_ret;_classCallCheck(this,PictureLoading);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=PictureLoading.__proto__||Object.getPrototypeOf(PictureLoading)).call.apply(_ref,[this].concat(args))),_this),_this.state={loaded:false},_this.handleImageLoad=function(){_this.setState({loaded:true});},_this.createSrcSetPath=function(url,urlx2){var media=arguments.length>2&&arguments[2]!==undefined?arguments[2]:null;return{srcSet:urlx2?[url,urlx2+' 2x'].join(', '):url,type:'image/jpeg',media:media};},_this.render=function(){var _this$props=_this.props,classes=_this$props.classes,image=_this$props.image,_this$props$image=_this$props.image,src=_this$props$image.src,_this$props$image$src=_this$props$image.src,small=_this$props$image$src.small,smallx2=_this$props$image$src.smallx2,medium=_this$props$image$src.medium,mediumx2=_this$props$image$src.mediumx2,large=_this$props$image$src.large,largex2=_this$props$image$src.largex2;var loaded=_this.state.loaded;if(!image||!src){console.warning('Missing image src!');return null;}var sources=[_this.createSrcSetPath(large,largex2,'(min-width: 1025px)'),_this.createSrcSetPath(medium,mediumx2,'(min-width: 641px)'),_this.createSrcSetPath(small,smallx2)];return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('picture',{className:__WEBPACK_IMPORTED_MODULE_2_classnames___default()(classes.picture)},sources.map(function(_ref2,index){var srcSet=_ref2.srcSet,media=_ref2.media,type=_ref2.type;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('source',{key:index,media:media,srcSet:srcSet,type:type});}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{className:__WEBPACK_IMPORTED_MODULE_2_classnames___default()(classes.image,_defineProperty({},classes.imageLoaded,loaded)),onLoad:_this.handleImageLoad,src:image.src.fpo||image.src.small||image.src.medium||image.src.large,alt:image.title||'picture'}));},_temp),_possibleConstructorReturn(_this,_ret);}return PictureLoading;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);PictureLoading.displayName='Image';PictureLoading.propTypes={classes:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,image:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({title:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,src:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({small:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,medium:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,large:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,smallx2:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,mediumx2:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,largex2:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,fpo:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string})})};PictureLoading.defaultProps={};/* harmony default export */ __webpack_exports__["default"] = (__WEBPACK_IMPORTED_MODULE_3_lodash_flow___default()([Object(__WEBPACK_IMPORTED_MODULE_4__material_ui_core_styles__["withStyles"])(__WEBPACK_IMPORTED_MODULE_5__picture_jss_js__["a" /* default */])])(PictureLoading));

/***/ }),

/***/ 360:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
function _defineProperty(obj,key,value){if(key in obj){Object.defineProperty(obj,key,{value:value,enumerable:true,configurable:true,writable:true});}else{obj[key]=value;}return obj;}/**
 * [Material UI theme documentation]{@link https://material-ui.com/customization/themes/}
 * [Material UI default theme object]{@link https://material-ui.com/customization/default-theme/}
 * @param {Object} theme - Material UI theme object
 * @returns {Object} - custom jss styles object
 *//* harmony default export */ __webpack_exports__["a"] = (function(theme){return{// eslint-disable-line no-unused-vars
picture:_defineProperty({display:'inline-block',width:'100%',height:'auto',overflow:'hidden',margin:0},theme.breakpoints.down('md'),{marginBottom:theme.spacing.unit*5.5}),image:_defineProperty({height:'auto',filter:'blur(15px)',transition:'transform .35s ease-in-out',maxHeight:166,'&:hover':{transform:'scale(1.07)'}},theme.breakpoints.down('md'),{width:248}),imageLoaded:{filter:'blur(0px)'}};});

/***/ }),

/***/ 4:
/***/ (function(module, exports) {

module.exports = require("classnames");

/***/ })

/******/ });
});
//# sourceMappingURL=PictureLoading.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/@makolab/library-react/dist/PictureLoading.js
// module id = 592
// module chunks = 0